import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Code, Layout, Terminal } from 'lucide-react';

const services = [
  {
    title: "Custom Web Development",
    description: "Bespoke responsive websites tailored to your unique business needs.",
    icon: <Layout className="w-10 h-10 text-[var(--brand-secondary)]" />,
  },
  {
    title: "Website Optimization",
    description: "Fixing bugs, improving speed, and ensuring mobile compatibility.",
    icon: <Terminal className="w-10 h-10 text-[var(--brand-secondary)]" />,
  },
  {
    title: "Digital Integration",
    description: "Setting up forms, booking systems, and email automation.",
    icon: <Code className="w-10 h-10 text-[var(--brand-secondary)]" />,
  },
];

const ServiceCard = ({ service }) => (
  <Card
    className="bg-[var(--bg-card)] border-[var(--border-medium)] hover:border-[var(--brand-secondary)] transition-all duration-300 group"
    data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, '-')}`}
  >
    <CardHeader>
      <div className="mb-6 p-4 rounded-full bg-[var(--bg-page)] w-fit group-hover:bg-[var(--brand-secondary)]/10 transition-colors">
        {service.icon}
      </div>
      <CardTitle className="text-2xl font-bold text-[var(--text-primary)] uppercase">
        {service.title}
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-[var(--text-secondary)] text-lg">{service.description}</p>
    </CardContent>
  </Card>
);

export const ServicesSection = () => (
  <section id="services" className="py-20 bg-transparent relative">
    <div className="container mx-auto px-6">
      <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-8">
        <div>
          <h2 className="heading-2 mb-4">Services</h2>
          <div className="h-1 w-20 bg-[var(--brand-secondary)]" />
        </div>
        <p className="text-[var(--text-secondary)] max-w-md text-lg">
          Professional solutions designed to help your business grow without the agency price tag.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {services.map((service) => (
          <ServiceCard key={service.title} service={service} />
        ))}
      </div>
    </div>
  </section>
);
